import { render, staticRenderFns } from "./Secuencia.vue?vue&type=template&id=52255876&lang=pug"
import script from "./Secuencia.vue?vue&type=script&lang=js"
export * from "./Secuencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports